import { isDraftMode, resolveScreenshot, type SupportEntry } from './supportContent';

import styles from './SupportArticlePage.module.css';

interface SupportFigureProps {
  entry: SupportEntry;
  /** The Markdown image target: a screenshot file name such as `the-gradebook.png`. */
  src?: string;
}

/**
 * An article image. The Markdown names a screenshot file; the entry supplies
 * the alt text, which is why an article may only reference screenshots the
 * entry declares. Phones get the 390px capture when one exists. Rendered as
 * phrasing content so it is valid inside the paragraph Markdown puts it in.
 */
export function SupportFigure({ entry, src }: SupportFigureProps) {
  const shot = src ? resolveScreenshot(entry, src) : undefined;

  if (!shot) {
    return isDraftMode() ? (
      <span className={styles.missingFigure} role="note">
        Missing screenshot: {src ?? '(no file)'}
      </span>
    ) : null;
  }

  return (
    <span className={styles.figure}>
      <picture>
        {shot.mobileSrc ? <source media="(max-width: 767px)" srcSet={shot.mobileSrc} /> : null}
        <img alt={shot.alt} className={styles.image} loading="lazy" src={shot.src} />
      </picture>
    </span>
  );
}
